'use client'

import {observer} from 'mobx-react'
import {useRouter} from 'nextjs-toploader/app'
import {usePathname, useSearchParams} from 'next/navigation'

import qs from 'qs'
import {useEffect, useState} from 'react'

import {Pagination as AntPagination, PaginationOptions} from '@/src/shared/ui/pagination'

import * as UI from './pagination.styled'

interface PaginationProps {
  showLimit?: boolean
  limit: number
  page: number
  total: number
}

export const PaginationContainer = observer(({limit, total, page, showLimit = true}: PaginationProps) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()

  const [currentLimit, setLimit] = useState(limit)
  const [currentPage, setPage] = useState(page)

  useEffect(() => {
    if (page != currentPage) {
      setPage(page)
    }
  }, [page])

  useEffect(() => {
    if (limit != currentLimit) {
      setLimit(limit)
    }
  }, [limit])

  const onChangePaginationOptions = (perPage: number) => {
    const currentSearchParams = qs.parse(searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.limit = perPage

    const queryParamsText = qs.stringify(queryParams)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  const onChangePage = (page: number) => {
    const currentSearchParams = qs.parse(new URL(location.href).searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.page = page

    const queryParamsText = qs.stringify(queryParams)

    setPage(page)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  return (
    <UI.Wrapper>
      {showLimit && (
        <UI.PaginationOptions as={PaginationOptions} perPage={currentLimit} onChange={onChangePaginationOptions} />
      )}
      <UI.DesktopPagination
        as={AntPagination}
        current={currentPage}
        total={total}
        pageSize={currentLimit}
        onChange={onChangePage}
      />
    </UI.Wrapper>
  )
})
